import { render, staticRenderFns } from "./ClientMaxLoanAmountAllowedInput.vue?vue&type=template&id=2984943a&scoped=true&"
import script from "./ClientMaxLoanAmountAllowedInput.vue?vue&type=script&lang=js&"
export * from "./ClientMaxLoanAmountAllowedInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2984943a",
  null
  
)

export default component.exports